var map = {
	"./alignment.scss": 861,
	"./border.scss": 8394,
	"./general.scss": 9608,
	"./icons.scss": 4974,
	"./links.scss": 4521,
	"./text.scss": 1371,
	"./util.scss": 716,
	"stylesheets/base/utilities/alignment.scss": 861,
	"stylesheets/base/utilities/border.scss": 8394,
	"stylesheets/base/utilities/general.scss": 9608,
	"stylesheets/base/utilities/icons.scss": 4974,
	"stylesheets/base/utilities/links.scss": 4521,
	"stylesheets/base/utilities/text.scss": 1371,
	"stylesheets/base/utilities/util.scss": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5738;